import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { Label } from '../Label';
export const Badge = (props)=>{
    const { className, ...rest } = props;
    const bsClass = classnames(className, 'rounded-pill');
    return /*#__PURE__*/ _jsx(Label, {
        ...rest,
        className: bsClass
    });
};
